import { render, staticRenderFns } from "./SelectDeliveryMethod.vue?vue&type=template&id=07943cf2&"
import script from "./SelectDeliveryMethod.vue?vue&type=script&lang=ts&"
export * from "./SelectDeliveryMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports